import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=90dbc16e&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=90dbc16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dbc16e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90dbc16e')) {
      api.createRecord('90dbc16e', component.options)
    } else {
      api.reload('90dbc16e', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=90dbc16e&scoped=true&", function () {
      api.rerender('90dbc16e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UsFQbjA80HTi/JS/teamMember.vue"
export default component.exports